import { render, staticRenderFns } from "./VMegamenu.vue?vue&type=template&id=20c62a79&"
import script from "./VMegamenu.vue?vue&type=script&lang=js&"
export * from "./VMegamenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports